export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => () => rootGetters['layoutModule/bottomSection'],
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    id: (state, getters) => element =>  getters.elements(element).id,
    index: () => () => 0,
    background: (state, getters) => element => getters.elements(element).background,
    content: (state, getters) => element => getters.elements(element).content,
    properties: (state, getters) => element => getters.elements(element).properties,
    assets: (state, getters) => element => getters.elements(element).assets,
  },
  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'bottomSectionModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'bottomSectionModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'bottomSectionModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
  }
}